import { render, staticRenderFns } from "./LocaleSelectItem.vue?vue&type=template&id=4f227d02&scoped=true&"
import script from "./LocaleSelectItem.vue?vue&type=script&lang=ts&"
export * from "./LocaleSelectItem.vue?vue&type=script&lang=ts&"
import style0 from "./LocaleSelectItem.vue?vue&type=style&index=0&id=4f227d02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f227d02",
  null
  
)

export default component.exports